type DiscountIntent = 'filter' | 'sort' | null;

interface trackingState {
  fromSectionId: string | null;
  // Stamped on product click (mirrors fromSectionId's stamp/consume model) rather than mirrored
  // continuously from live catalog state - a continuously-mirrored flag needs a reset trigger,
  // and "the catalog page unmounted" fires on ordinary PDP navigation too, wiping the signal
  // before addToCart can read it. Keyed to the clicked product's uuid so addToCart only
  // attributes the discount to the product actually clicked, not to whatever the catalog page's
  // state happens to be when the add occurs.
  discountIntentProductUuid: string | null;
  discountIntent: DiscountIntent;
}

const trackingState: trackingState = {
  fromSectionId: null,
  discountIntentProductUuid: null,
  discountIntent: null,
};

export default {
  namespaced: true,
  state: trackingState,
  actions: {
    setFromSectionId: async ({ commit }, sectionId) => {
      commit('setFromSectionId', sectionId);
    },
    resetSectionId: ({ commit }) => {
      commit('setFromSectionId', null);
    },
    setDiscountIntent: ({ commit }, payload: { productUuid: string; discountIntent: DiscountIntent }) => {
      commit('setDiscountIntent', payload);
    },
    resetDiscountIntent: ({ commit }) => {
      commit('setDiscountIntent', { productUuid: null, discountIntent: null });
    },
  },
  mutations: {
    setFromSectionId: (state, sectionId) => {
      state.fromSectionId = sectionId;
    },
    setDiscountIntent: (state, { productUuid, discountIntent }: { productUuid: string | null; discountIntent: DiscountIntent }) => {
      state.discountIntentProductUuid = productUuid;
      state.discountIntent = discountIntent;
    },
  },
  getters: {
    sectionId(state): string {
      return state.fromSectionId;
    },
    discountIntent(state) {
      return (productUuid: string): DiscountIntent => (productUuid === state.discountIntentProductUuid ? state.discountIntent : null);
    },
  },
};
